import React from 'react';
import { Message } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

export default function MessageValidationBank({ sendMail }) {
    const { t } = useTranslation();
    return (
        <Message
            title={t(`ticket.organiser.message_bank.title`)}
            type="danger"
            visible
            links={{ label: t('ticket.organiser.message_bank.action_label'), onClick: () => sendMail() }}
        >
            {t(`ticket.organiser.message_bank.content`)}
        </Message>
    );
}
MessageValidationBank.propTypes = {
    sendMail: PropTypes.func.isRequired
};
